import { Reveal } from "@/lib/motion";

// Numbered manifesto chapter header
export const Chapter = ({ num, title, kicker }) => (
  <div className="flex items-end justify-between gap-6 flex-wrap mb-14 md:mb-20">
    <Reveal>
      <div className="flex items-start gap-5 md:gap-8">
        <span className="font-mono-plex text-[#b5423a] text-sm md:text-base pt-3 md:pt-4">
          {num}
        </span>
        <h2 className="font-serif-display font-light text-[#16324f] text-[clamp(2.4rem,6vw,4.5rem)] leading-[0.9] tracking-[-0.02em]">
          {title}
        </h2>
      </div>
    </Reveal>
    {kicker && (
      <Reveal delay={0.1}>
        <span className="font-mono-plex text-[13.5px] font-medium uppercase tracking-[0.16em] text-[#3a4d5c]">
          {kicker}
        </span>
      </Reveal>
    )}
  </div>
);
